/**
 * @public
 */
export var Callback;
(function (Callback) {
    function contraMap(callback, mapper) {
        return (value, ...args) => callback(mapper(value), ...args);
    }
    Callback.contraMap = contraMap;
})(Callback || (Callback = {}));
//# sourceMappingURL=callback.js.map